// AddBudgetModal.js
import React from "react";
import { FaTimes } from "react-icons/fa";
import "./anggaran.css";

export default function AddBudgetModal({
  formData,
  handleStartDateChange,
  handleInputChange,
  handleSave,
  onClose,
}) {
  return (
    <div className="modal-overlay-agr">
      <div className="modal-content-agr">
        <button className="close-btn-agr" onClick={onClose}>
          <FaTimes />
        </button>
        <h3>Tambah Anggaran</h3>

        <div className="modal-body-agr">
          <div className="form-group-agr">
            <label>Start Date:</label>
            <input
              type="date"
              name="startDate"
              value={formData.startDate}
              onChange={handleStartDateChange}
            />
          </div>

          <div className="form-group-agr">
            <label>End Date (+30 hari):</label>
            <input
              type="date"
              name="endDate"
              value={formData.endDate}
              readOnly
            />
          </div>

          <div className="form-group-agr">
            <label>Makanan & Kebutuhan Rumah Tangga:</label>
            <input
              type="text"
              name="makanan"
              value={formData.makanan}
              onChange={handleInputChange}
              placeholder="Masukkan nominal (Rp)"
            />
          </div>

          <div className="form-group-agr">
            <label>Transportasi:</label>
            <input
              type="text"
              name="transportasi"
              value={formData.transportasi}
              onChange={handleInputChange}
              placeholder="Masukkan nominal (Rp)"
            />
          </div>

          <div className="form-group-agr">
            <label>Konektivitas:</label>
            <input
              type="text"
              name="konektivitas"
              value={formData.konektivitas}
              onChange={handleInputChange}
              placeholder="Masukkan nominal (Rp)"
            />
          </div>

          <div className="form-group-agr">
            <label>Hiburan:</label>
            <input
              type="text"
              name="hiburan"
              value={formData.hiburan}
              onChange={handleInputChange}
              placeholder="Masukkan nominal (Rp)"
            />
          </div>

          <div className="form-group-agr">
            <label>Tagihan & Lainnya:</label>
            <input
              type="text"
              name="tagihan"
              value={formData.tagihan}
              onChange={handleInputChange}
              placeholder="Masukkan nominal (Rp)"
            />
          </div>

          <button className="btn save-btn" onClick={handleSave}>
            Simpan
          </button>
        </div>
      </div>
    </div>
  );
}